'use client'

import { Toast } from "primereact/toast";
import { RefObject } from "react";

// toast setup
export function setToastRef (newToastRef: RefObject<Toast | null>) {
  toastRef = newToastRef;
}

export let toastRef: RefObject<Toast | null>;